<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options">

      <template slot="beforeTable">
        <datatable-loader :name="tableName"/>
      </template>
    </v-server-table>
  </div>
</template>
<script>
import { mapState } from 'vuex';

const TableName = 'VUETABLE_SNAPSHOT';
export default {
    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: [
                'code',
                'name',
                'total_quantity',
                'net_sales',
                'total_sales',
            ],
            options: {
                texts: {
                    title: 'Product Sales',
                    description: 'Shows product sale details',
                },
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                headings: {
                    code: 'Barcode',
                    name: 'Product Name',
                    total_quantity: 'Quantity (#)',
                    net_sales: 'Net Sales (RM)',
                    total_sales: 'Total Sales (RM)',
                },
                columnsClasses: {
                    total_quantity: 'text-right',
                    net_sales: 'text-right',
                    total_sales: 'text-right',
                },
                pdf_url: Laroute.route(
                    'franchise.report.snapshot.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.snapshot.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.snapshot.exportAsFile',
                    { type: 'XLSX' },
                ),
                requestFunction: function(request) {
                    return axios
                        .post(this.url, request)
                        .catch(e => this.dispatch('error', e));
                },
                export_post: true,
                export_filename: 'Product Sales Report',
            },
        };
    },
    computed: {
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route('franchise.report.snapshot.product');
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 2000;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/snapshot/vuetable_snapshot.vue